var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"home-main"},[_c('img',{attrs:{"alt":"logo","src":require("../../assets/logo.png")}}),_c('div',[_vm._v(" "+_vm._s(_vm.company)+"-代理商管理平台 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }